import { atomWithStorage } from "jotai/utils";

export type ActivitiesFiltersState = {
	dateFrom: Date | null;
	dateTo: Date | null;
	types: string[];
	created: string[];
};

export const defaultActivitiesFiltersState: ActivitiesFiltersState = {
	dateFrom: null,
	dateTo: null,
	types: [],
	created: [],
};

export const activitiesFiltersState = atomWithStorage<ActivitiesFiltersState>(
	"MYPLANN_ACTIVITIES_FILTERS_STATE",
	defaultActivitiesFiltersState,
);
